module.exports = __webpack_public_path__ + "static/media/user_group.da6e5f40.svg";